// extracted by mini-css-extract-plugin
export var icon = "industriesHero-module--icon--JiI0U";
export var industriesHero = "industriesHero-module--industriesHero--JFtrW";
export var sbShowMain = "industriesHero-module--sb-show-main--38Jjx";